import type { HTMLProps } from 'react';
import React from 'react';

type Axis = 'vertical' | 'horizontal';

interface IProps extends Omit<HTMLProps<HTMLSpanElement>, 'size'> {
  axis: Axis;
  size: number;
}

const VERTICAL_SIZE: Record<number, string> = {
  6: 'h-1.5 w-px',
  8: 'h-2 w-px',
  16: 'h-4 w-px',
  20: 'h-5 w-px',
  24: 'h-6 w-px',
  32: 'h-8 w-px',
  40: 'h-10 w-px'
};

const HORIZONTAL_SIZE: Record<number, string> = {
  6: 'h-px w-1.5',
  8: 'h-px w-2',
  16: 'h-px w-4',
  20: 'h-px w-5',
  24: 'h-px w-6',
  32: 'h-px w-8',
  40: 'h-px w-10'
};

export const Space = ({ size, axis, className, ...delegated }: IProps) => {
  const sizeClass = (axis === 'vertical' ? VERTICAL_SIZE : HORIZONTAL_SIZE)[size] ?? (axis === 'vertical' ? 'h-4 w-px' : 'h-px w-4');

  return <span className={['block', sizeClass, className].filter(Boolean).join(' ')} {...delegated} />;
};
